import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

// Booking reminders (spec 055 D20): the settings, the last run and the test send sit behind three
// callables that check canSend; nothing here reads Firestore. Errors are rethrown, like the other
// staff doors — a failure must never look like success.
const callable = (name) => async (payload) => {
  const { data } = await httpsCallable(functions, name)(payload);
  return data;
};

// → { settings, lastRun, testAccounts }
export const getBookingReminders = callable("getBookingReminders");
// { settings } → { ok: true }; a refused value throws with the reason as its message.
export const setBookingReminders = callable("setBookingReminders");
// { uid, key, title, body } → { devices }
export const sendTestBookingReminder = callable("sendTestBookingReminder");
